// config
import theme from 'config/theme';

// types
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';
import { TFunction } from 'i18next';
import { FlexMatchTaskResponse } from 'RestAPIs/flex-match/types';

export const getMatchStatusIcon = (
  row: FlexMatchTaskResponse,
  t: TFunction<'common', undefined>
): { icon: IconType; color: string; tooltip?: string } | null => {
  const { flexPortalMatchFlags, flexPortalMatchStatus, isAutoMatch } = row;

  const status = [
    {
      test: () => isAutoMatch,
      icon: 'double-sparkle',
      color: theme.palette.info.main
    },
    {
      test: () => flexPortalMatchFlags.includes('ALL_REPLIED_UNAVAILABLE'),
      icon: 'user-xmark',
      color: 'error',
      tooltip: t('replyAvailable')
    },
    {
      test: () => flexPortalMatchFlags.includes('ONE_REPLIED_AVAILABLE'),
      icon: 'user-check',
      color: theme.vars.palette.success.onFixedVariant,
      tooltip: t('replyAvailable')
    },
    {
      test: () => flexPortalMatchFlags.includes('WAITING_FOR_REPLY'),
      icon: 'arrow-down-arrow-up',
      color: theme.vars.palette.info.onContainer,
      tooltip: t('awaitingReply')
    },
    {
      test: () => flexPortalMatchStatus === 'ACCEPT_REQUEST',
      icon: 'user',
      color: theme.palette.info.main
    }
  ];

  const match = status.find((match) => match.test());
  return match ?? null;
};
